import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@mui/material/Grid';
import { Button } from '@material-ui/core';
import axios from 'axios';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Backdrop, CircularProgress, Typography, MenuItem, Select, InputLabel} from "@mui/material";
import Box from '@mui/material/Box';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';

import '../css/login.css'

const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/patient/create";


const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));



function getSteps() {
    return ['Datos Personales'];
}

function getStepContent(stepIndex, classes,  body, handleChange, handleChangeDate, isEditing) {

    switch (stepIndex) {
      
        case 0:
          
        return (<div>
            <FormControl className={classes.root}>
                <Grid container className="container">
                <Grid item xs={12} sm={6} md={4}>
                    <Box color='GrayText' fontSize={20}>
                            <InputLabel id="typeIdLabel">Tipo de Identificacion:</InputLabel>
                                <Select
                                    labelId="typeIdLabel"
                                    id='typeId'
                                    name="typeId"
                                    defaultValue={"CC"}
                                    value={body.typeId}
                                    onChange={handleChange}
                                    label="Tipo de Identificacion">
                                    <MenuItem value={"CC"}>Cedula de Ciudadania</MenuItem>
                                    <MenuItem value={"TI"}>Tarjeta de identidad</MenuItem> 
                                    <MenuItem value={"CE"}>Cedula de Extranjeria</MenuItem>    
                                    <MenuItem value={"RC"}>Registro Civil</MenuItem> 
                                </Select>
                                </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Cedula</Typography>
                        <TextField
                            id='id'
                            name='id'
                            value={body.id}
                            onChange={handleChange}
                            disabled={isEditing}
                            variant='outlined'
                            aria-label="minimum height"
                         
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Confirmar Cedula</Typography>
                        <TextField
                            id='idAux'
                            name='idAux'
                            value={body.idAux}
                            onChange={handleChange}
                            disabled={isEditing}
                            variant='outlined'
                            aria-label="minimum height"
                            error={body.idAux != "" && body.id != body.idAux}
                            helperText={body.idAux != "" &&  body.id != body.idAux ? 'La Cedula deben coincidir' : ''}
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Primer Nombre</Typography>
                        <TextField
                            id='firstName'
                            name='firstName'
                            value={body.firstName}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Segundo Nombre</Typography>
                        <TextField
                            id='secondName'
                            name='secondName'
                            value={body.secondName}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Primer Apellido</Typography>
                        <TextField
                            id='lastName'
                            name='lastName'
                            value={body.lastName}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Segundo Apellido</Typography>
                        <TextField
                            id='secondLastName'
                            name='secondLastName'
                            value={body.secondLastName}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Celular</Typography>
                        <TextField
                            id='cellphone'
                            name='cellphone'
                            value={body.cellphone}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Correo Electronico</Typography>
                    <TextField
                        id='email'
                        name='email'
                        value={body.email}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"
                        />
                
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Direccion</Typography>
                    <TextField
                        id='address'
                        name='address'
                        value={body.address}
                        onChange={handleChange}
                        variant='outlined'
                        aria-label="minimum height"
                        />
                
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    <Box color='GrayText' fontSize={20}>
                            <InputLabel id="residenceCodeLabel">Departamento:</InputLabel>
                                <Select
                                    labelId="residenceCodeLabel"
                                    id='residenceCode'
                                    name="residenceCode"
                                    defaultValue={"RIOHACHA"}
                                    value={body.residenceCode}
                                    onChange={handleChange}
                                    label="Departamento">
                                    <MenuItem value={"RIOHACHA"}>RIOHACHA</MenuItem>
                                    <MenuItem value={"ALBANIA"}>ALBANIA</MenuItem>
                                    <MenuItem value={"BARRANCAS"}>BARRANCAS</MenuItem>
                                    <MenuItem value={"DIBULLA"}>DIBULLA</MenuItem>
                                    <MenuItem value={"DISTRACCION"}>DISTRACCION</MenuItem>
                                    <MenuItem value={"EL MOLINO"}>EL MOLINO</MenuItem>
                                    <MenuItem value={"FONSECA"}>FONSECA</MenuItem>
                                    <MenuItem value={"HATONUEVO"}>HATONUEVO</MenuItem>
                                    <MenuItem value={"LA JAGUA DEL PILAR"}>LA JAGUA DEL PILAR</MenuItem>
                                    <MenuItem value={"MAICAO"}>MAICAO</MenuItem>
                                    <MenuItem value={"MANAURE"}>MANAURE</MenuItem>
                                    <MenuItem value={"SAN JUAN DEL CESAR"}>SAN JUAN DEL CESAR</MenuItem>
                                    <MenuItem value={"URIBIA"}>URIBIA</MenuItem>
                                    <MenuItem value={"URUMITA"}>URUMITA</MenuItem>
                                    <MenuItem value={"VILLANUEVA"}>VILLANUEVA</MenuItem>
                                   
                                </Select>
                                </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>EPS</Typography>
                        <TextField
                            id='eps'
                            name='eps'
                            value={body.eps}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    <Box color='GrayText' fontSize={20}>
                            <InputLabel id="regimenLabel">Regimen:</InputLabel>
                                <Select
                                    labelId="regimenLabel"
                                    id='regimen'
                                    name="regimen"
                                    defaultValue={"Contributivo"}
                                    value={body.regimen}
                                    onChange={handleChange}
                                    label="Regimen">
                                    <MenuItem value={"Contributivo"}>Contributivo</MenuItem>
                                    <MenuItem value={"Subsidiado"}>Subsidiado</MenuItem> 
                                   
                                </Select>
                                </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    <Box color='GrayText' fontSize={20}>
                            <InputLabel id="genderLabel">Genero:</InputLabel>
                                <Select
                                    labelId="genderLabel"
                                    id='gender'
                                    name="gender"
                                    defaultValue={"FEMENINA"}
                                    value={body.gender}
                                    onChange={handleChange}
                                    label="Genero">
                                    <MenuItem value={"MASCULINO"}>MASCULINO</MenuItem>
                                    <MenuItem value={"FEMENINA"}>FEMENINA</MenuItem> 
                                   
                                </Select>
                                </Box>
                    </Grid>
                   
                    
                    <Grid item xs={12} sm={6} md={4}>
                    
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MobileDatePicker
                                id='birthday'
                                name='birthday'
                                label="Fecha de Nacimiento"
                                inputFormat="MM/dd/yyyy"
                                value={body.birthday}
                                onChange={handleChangeDate}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                       
                    
                    </Grid>
                    
                    
                </Grid>
            </FormControl>
        </div>);
   
      default:
            return 'Unknown stepIndex';
    }
}


function CreatePatient(props) {
    const classes = useStyles();
    const [body, setBody] = useState({
        id: props.affiliateInfo.id,
        idAux: props.affiliateInfo.id,
        firstName: props.affiliateInfo.firstName,
        secondName: props.affiliateInfo.secondName,
        lastName: props.affiliateInfo.lastName,
        secondLastName: props.affiliateInfo.secondLastName,
        cellphone: props.affiliateInfo.cellphone,
        email: props.affiliateInfo.email,
        address: props.affiliateInfo.address,
        gender: props.affiliateInfo.gender,
        eps: props.affiliateInfo.eps,
        typeId: props.affiliateInfo.typeId,
        regimen: props.affiliateInfo.regimen,
        residenceCode: props.affiliateInfo.residenceCode,
        birthday: props.affiliateInfo.birthday ?  props.affiliateInfo.birthday : new Date(),
       
    })
    const [activeStep, setActiveStep] = React.useState(0);
    const [openLoader, setOpenLoader] = React.useState(false);
    const isEditing = props.affiliateInfo.id != "";
    const steps = getSteps();

    const handleChange = e => {
        setBody({
            ...body,
            [e.target.name]: e.target.value
        })
    }

    const handleChangeDate = (newValue) => {
        setBody({
            ...body,
            ["birthday"]: newValue
        })
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    
    return (
        <div>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <div>{getStepContent(activeStep, classes, body, handleChange, handleChangeDate, isEditing)}</div>


            <div>

                <div>
                    <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={"buttonBack"}>
                        Back
                    </Button>
                    <Button variant="contained" className="buttonNext"
                        color="primary" onClick={() => {

                            if (body.id == body.idAux) {
                            if(activeStep === steps.length - 1) {
                                setOpenLoader(true);
                                let patient = [];
                                patient.push(body);
                                axios.post(url, patient).then(response => {
                                
                                setOpenLoader(false);
                                props.changeMenu(3);
                                
                                
                            });
                            } else {
                                handleNext();
                            }
                        }
                        }}>
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                </div>
            </div>


            <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openLoader}>
            <CircularProgress color="inherit" />
        </Backdrop>
        </div>
    );
};

export default CreatePatient;